import React from "react";
import img from "../assets/banner4.png"; 

const AyushBanner = () => {
  return (
    <div className="px-2 md:px-0 w-full mt-4 md:mt-10">
      <div className="w-full relative overflow-hidden rounded-xl md:rounded-2xl shadow-sm 
                      bg-[#f3f4f6] flex items-center justify-center
                      h-[200px] sm:h-[300px] md:h-[450px] lg:h-[60vh]">
        
        {/* Background Image - Object Contain use kiya hai taaki content na kate */}
        <img
          src={img}
          alt="Ayushvatika Banner"
          className="w-full h-full object-contain md:object-cover object-center"
        />
        
      </div>
    </div>
  );
};

export default AyushBanner;